<div class="w-100 d-flex flex-column justify-content-center align-items-center text-am-white" >
  <div>
    <video class="w-100" autoplay
           [ngClass]="classStyle"
           loop
           [width]="widthVideo"
           [height]="heightVideo"
           [src]="this.srcComponent + '.webm'">
      <source [src]="this.srcComponent + '.mp4'" type="video/mp4">
      <source [src]="this.srcComponent + '.webm'" type="video/webm">
    </video>
  </div>
</div>
